module.exports = __webpack_public_path__ + "static/media/perifericos.78df4fda.svg";